import * as yup from 'yup';
export const validatedEpicAccountSchema = yup.object({
    clientId: yup.string().required(),
    accountName: yup.string().required(),
    lookupCode: yup.string().required(),
    phoneNumber: yup.string().optional(),
    postalCode: yup.string().required(),
    overrideCcFee: yup.number().integer().nullable().defined(),
    overrideAchFee: yup.number().integer().nullable().defined(),
    overrideEftFee: yup.number().integer().nullable().defined(),
});
export const createCustomerUserAccountSchema = yup.object({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().required(),
    accountNumber: yup.string(),
    validatedEpicAccount: validatedEpicAccountSchema.optional().default(undefined),
});
export const requestCustomerUserAccountVerificationCodeSchema = yup.object({
    email: yup.string().email().required(),
});
export const loginCustomerUserAccountSchema = yup.object({
    email: yup.string().email().required(),
    verificationCode: yup.string().required(),
    validatedEpicAccount: validatedEpicAccountSchema.optional().default(undefined),
});
//# sourceMappingURL=customerUserAuth.js.map